const special = {
    // Emma meeting id
    215: {
        // TCT 2024
        suppressEvents: [],
    },
    199: {
        // TCT 2023
        // suppress these events everywhere on portal pages
        suppressEvents: [],
        // suppress these events from on-demand display
        suppressOndemand: [
            97812, 98430, 98116, 98348, 97941, 98565, 98166, 97821, 98052, 99522, 99532, 99536, 99524, 99534, 99538,
            99395, 99393, 99416, 99413, 99431, 99435, 97600, 98005, 97727, 98316, 98569, 99429, 98474, 98099, 98576,
        ],
    },
    189: {
        // TVT 2022
        suppressEvents: [89696, 89412, 89794, 89168, 89765, 89682],
    },
    187: {
        // CTO 2022
        suppressEvents: [87044, 87099, 87101, 87105, 87480, 87428],
    },
    178: {
        // THT 2022
        suppressEvents: [87158, 87154, 87166, 87159, 87160, 87161, 87162, 87163, 87164],
    },
    177: {
        alternateLinks: {
            86703: "https://www.tctmd.com/registration-latest-transcatheter-repair-therapies-mitral-regurgitation-teer-annuloplasty", // Latest in Transcatheter Repair Therapies for Mitral Regurgitation: TEER, Annuloplasty& Chordal Repair
        },
    },
    176: {
        // suppress these events on portal pages
        suppressEvents: [
            79108, // Live case #2
            79127, // Live case #5
            79157, // Live case #11
            79193, // Live case #15
            79213, // Live cases #18 & #19
            79218, // Live case #20
            79182, // Master class #7
        ],
        // alternate URLs for events in the program guide & faculty profile page
        alternateLinks: {
            80898: "", // Achieving Optimal Outcomes with an Intra-Annular Self-Expanding TAVR System
            80489: "https://www.tctmd.com/registration-Tricuspid-Valve-Therapies-Why-a-Transcatheter-Toolbox-is-Required", // Tricuspid Valve Therapies:  Why a Transcatheter Toolbox Is Required
            80477: "https://www.tctmd.com/Registration-Aortic-Stenosis-TAVR-ViV-TAVR-Peri-procedural-Hemodynamics", // Aortic Stenosis, TAVR, ViV-TAVR, SAVR:  Peri-procedural Hemodynamics
        },
    },
}

export default special
